import { useEffect, useRef } from 'react';

interface SEOUpdateParams {
  title?: string;
  artist?: string;
  isPlaying?: boolean;
}

const DEFAULT_TITLE = 'Радио Афродита - Знакомо и Танцевально! | radioafrodita.com';

/**
 * Упрощенный хук для обновления только document.title
 * (остальные мета-теги статичны в HTML)
 */
export const useSEO = ({ title, artist, isPlaying = false }: SEOUpdateParams) => {
  const prevTitleRef = useRef<string | undefined>(title);
  const prevArtistRef = useRef<string | undefined>(artist);
  const prevPlayingRef = useRef<boolean>(isPlaying);

  useEffect(() => {
    // Проверяем, изменились ли значения
    const titleChanged = prevTitleRef.current !== title;
    const artistChanged = prevArtistRef.current !== artist;
    const playingChanged = prevPlayingRef.current !== isPlaying;
    
    // Если ничего не изменилось, пропускаем обновление
    if (!titleChanged && !artistChanged && !playingChanged) {
      return;
    }

    // Обновляем ref для следующего сравнения
    prevTitleRef.current = title;
    prevArtistRef.current = artist;
    prevPlayingRef.current = isPlaying;

    // Формируем динамический title
    let pageTitle = DEFAULT_TITLE;
    
    if (title && artist && isPlaying) {
      // Обрезаем длинные названия для title
      const trackTitle = title.length > 35 ? title.substring(0, 32) + '...' : title;
      const artistName = artist.length > 20 ? artist.substring(0, 17) + '...' : artist;
      pageTitle = `${artistName} - ${trackTitle} | Радио Афродита - Знакомо и Танцевально!`;
    } else if (title && isPlaying) {
      const trackTitle = title.length > 40 ? title.substring(0, 37) + '...' : title;
      pageTitle = `${trackTitle} | Радио Афродита - Знакомо и Танцевально!`;
    }

    // Обновляем document.title только если он изменился
    if (document.title !== pageTitle) {
      document.title = pageTitle;
    }

    // Cleanup: возвращаем значение по умолчанию при размонтировании
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, artist, isPlaying]);
};
